import { cloneElement, h, Component, isValidElement, toChildArray, VNode } from 'preact'
import cn from 'classnames'
import s from './Steps.css'

interface iChildProps {
  id: number
}

interface iProps {
  className?: string
  activeStep: number | string
}

export class Wrap extends Component<iProps> {
  render () {
    const { children, className, activeStep } = this.props

    return (
      <div className={cn(s.Steps, className)}>
        {toChildArray(children)
          .filter((child: VNode<iChildProps>) => (
            isValidElement(child) &&
            child.props.id === activeStep
          ))
          .map((child: any) => cloneElement(child, { activeStep }))
        }
      </div>
    )
  }
}
